<template>
    <div class="modal vc_modal my_account_modal" :class="{ 'show': showEditModal}">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content my_account_modal_content p_0">
                <button type="button" class="btn-close" @click="closeModal()"></button>
                <div class="modal-body p_0">
                    <h5 class="common_subtitle pb_15  font_18p border-lightgray-bottom pt_15 pl_15">{{ modalData?.server_name }}</h5>
                    
                    <div class="p_20">
                        <div class="row">
                            <div class="col-12"> 
                                <div class="mb-3">
                                    <label for="server_name" class="col-form-label">Server name</label>
                                    <input type="text" class="form-control" id="server_name" v-model="form.server_name">
                                    <v-errors :errors="errorFor('server_name')"></v-errors>
                                </div>
                                <div class="mb-3">
                                    <div class="d_flex_start">
                                        <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading" @click.prevent="updateServerName">Update</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "update-hostname-modal",
    components: {},
    props: {
        showEditModal: {
            type: Boolean,
            required: true
        },
        modalData: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            cloudServers: [],
            form: {
                server_name: this.modalData?.server_name,
                cloud_server_id: this.modalData?.id,
            }
        }
    },
    watch: {
        
    },
    created() {
    },
    methods: {
        updateServerName() {

          let apiUrl;
          if (this.modalData.proxmox_vm_id && !this.modalData.kt_platform) {
            apiUrl = `/proxmox/rename-vm-host/${this.modalData.id}`
          } else {
            apiUrl = '/update-cloud-server-name'
          }

            this.$swal({
                title: 'Are you sure want to update?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, update it!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    this.axios.post(apiUrl,this.form)
                    .then((response) => {
                        if(response.data.success){
                            this.closeModal();
                            this.showSuccessMsg(response.data.message);
                        }else{
                            this.$swal({
                                text: response.data.message,
                                showCancelButton: false,
                                confirmButtonText: 'Close!',
                                confirmButtonColor: '#dd4b39',
                                reverseButtons: true
                            })
                        }
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors
                        this.showFailMsg(err.response.data.message);
                    });
                }
            });
        },
        closeModal() {
            this.$emit('closeEditModal', this.form.server_name)
        }
    }
}
</script>
<style scoped>
    .modal{
        background-color: rgb(0 0 0 / 15%);
    }
</style>
